import { Team } from '@data/team/team.model';

import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { TeamActions } from '@data/team/team.actions';
import { TeamQuery } from '@data/team/team.query';
import { RouteDataLoader } from '@core/router/resolvers/route-data-loader';

@Injectable({
  providedIn: 'root',
})
export class TeamResolver {
  private teamQuery = inject(TeamQuery);
  private loader = inject(RouteDataLoader);

  resolve(): Observable<Team> {
    TeamActions.loadTeamsForUser();
    return this.loader.awaitOrFail(this.teamQuery.selectWhenTruthyActiveTeam$);
  }
}
